export default "__VITE_PUBLIC_ASSET__722f0f5a__"